import moment from "moment-timezone";
import { classNames } from "../../utils/helperFuctions";
import { Link } from "react-router-dom";

const DisplayDataItem = ({
  title,
  item1,
  item2,
  countryCode,
  badgeBg,
  isDate,
  isEmail,
  isPhone,
  isLocation,
  placeholder,
  linkTo,
}) => {
  const formatDateTime = (date1, countryCode) => {
    const timezone = countryCode === "LB" ? "Asia/Beirut" : "Asia/Dubai";
    const momentTime = moment
      .utc(date1.includes("Z") ? date1 : date1 + "Z")
      .tz(timezone);

    return momentTime.format("DD-MM-YYYY hh:mm A");
  };

  // Handle empty/null values with placeholder
  const displayValue = item1 || placeholder;
  const shouldFormatAsDate = isDate && item1; // Only format if we have actual data

  let url = "";
  if (isLocation) {
    const parts = displayValue
      .split("+")
      .join("%2B")
      .split(/[-\s,]+/)
      .join("+");
    url = `https://www.google.com/maps/search/${parts}`;
  }

  // Main display block (includes item1 and item2)
  const displayBlock = (
    <div className={`${item2 != null && "flex gap-1"}`}>
      {isPhone ? (
        <a className="text-primary hover:underline" href={`tel:${displayValue}`}>
          {displayValue}
        </a>
      ) : isEmail ? (
        <a
          className="text-primary hover:underline"
          href={`mailto:${displayValue}`}
          target="_blank"
          rel="noreferrer"
        >
          {displayValue}
        </a>
      ) : shouldFormatAsDate ? (
        <div>{formatDateTime(item1, countryCode)}</div>
      ) : isLocation ? (
        <a
          className="text-primary hover:underline"
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          {displayValue}
        </a>
      ) : badgeBg != null ? (
        <div
          className={classNames(
            `w-full inline-flex items-center rounded-md px-2 py-2 mt-2 text-xs font-medium ring-1 ring-inset`,
            badgeBg
          )}
        >
          {displayValue}
        </div>
      ) : (
        <div>{displayValue}</div>
      )}
      {item2 != null && <div>{item2}</div>}
    </div>
  );

  // Wrap the whole block in Link if linkTo is provided
  const wrappedContent = linkTo ? (
    <Link className="text-primary hover:underline" to={linkTo}>
      {displayBlock}
    </Link>
  ) : (
    displayBlock
  );

  return (
    <div>
      <div className="block text-sm font-medium leading-6 text-gray-900 text-left">
        {title}
      </div>
      <div className="flex gap-1 w-full sm:text-sm sm:leading-6 text-[#6b7280] font-medium disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200">
        {wrappedContent}
      </div>
    </div>
  );
};

export default DisplayDataItem;
